import { ApplyForEoriCTA } from "./ctas";
export var ApplyForEoriIA = function ApplyForEoriIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return APPLY_FOR_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize, articles) {
  return ApplyForEoriCTA(strictLocalize, articles);
};
var APPLY_FOR_EORI = function APPLY_FOR_EORI(strictLocalize) {
  return strictLocalize({
    id: "w1hyF6",
    defaultMessage: [{
      "type": 0,
      "value": "EORI-nummer aanvragen"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "elnXE+",
    defaultMessage: [{
      "type": 0,
      "value": "Een EORI-nummer kan handig zijn om mogelijke vertragingen en opslagkosten te voorkomen als je bestelling niet tijdig door de douane kan worden verwerkt. We raden je daarom aan een EORI-nummer aan te vragen als je goederen uit een ander land importeert. Hieronder vind je landspecifieke links om een EORI-nummer aan te vragen."
    }]
  });
};